module.exports = __webpack_public_path__ + "static/media/copy-clipboard.cec0f785.svg";